import { Box } from '@mui/material';
import {
  FunctionField,
  InputProps,
  Labeled,
  required,
  TextInput,
  useRecordContext,
  WrapperField,
} from 'react-admin';
import { IntegrationRecord } from '../../../common/types';
import IntegrationInfo from './IntegrationInfo';

const WebhookUrl = () => {
  const record = useRecordContext();

  if (!(record && record.id)) return null;

  const urlBase = 'https://it3.suitepad.systems/v2/webhooks/shiji/';
  const webhookId = record.integrationUuid.split('-').slice(1, -1).join('-');

  return (
    <Labeled label="resources.integrations.fields.shiji.webhookUrl.label">
      <FunctionField render={() => urlBase + webhookId} />
    </Labeled>
  );
};

const ShijiInputs = ({
  integration,
}: Omit<InputProps, 'source'> & { integration: IntegrationRecord }) => (
  <WrapperField>
    <IntegrationInfo integration={integration} />
    <Box width="70%" maxWidth="70%">
      <TextInput
        source="currentConfig.service.apiEndpointUrl"
        label="resources.integrations.fields.shiji.apiEndpointUrl.label"
        helperText="resources.integrations.fields.shiji.apiEndpointUrl.helperText"
        validate={required(
          'resources.integrations.fields.shiji.apiEndpointUrl.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.timezone"
        label="resources.integrations.fields.shiji.timezone.label"
        helperText="resources.integrations.fields.shiji.timezone.helperText"
        validate={required(
          'resources.integrations.fields.shiji.timezone.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.clientId"
        label="resources.integrations.fields.shiji.clientId.label"
        helperText="resources.integrations.fields.shiji.clientId.helperText"
        validate={required(
          'resources.integrations.fields.shiji.clientId.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.clientSecret"
        label="resources.integrations.fields.shiji.clientSecret.label"
        helperText="resources.integrations.fields.shiji.clientSecret.helperText"
        validate={required(
          'resources.integrations.fields.shiji.clientSecret.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.password"
        label="resources.integrations.fields.shiji.password.label"
        helperText="resources.integrations.fields.shiji.password.helperText"
        validate={required(
          'resources.integrations.fields.shiji.password.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.propertyCode"
        label="resources.integrations.fields.shiji.propertyCode.label"
        helperText="resources.integrations.fields.shiji.propertyCode.helperText"
        validate={required(
          'resources.integrations.fields.shiji.propertyCode.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.propertyId"
        label="resources.integrations.fields.shiji.propertyId.label"
        helperText="resources.integrations.fields.shiji.propertyId.helperText"
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.defaultCheckOutTime"
        label="resources.integrations.fields.shiji.defaultCheckOutTime.label"
        helperText="resources.integrations.fields.shiji.defaultCheckOutTime.helperText"
        validate={required(
          'resources.integrations.fields.shiji.defaultCheckOutTime.helperText'
        )}
        variant="outlined"
        fullWidth
      />
      <TextInput
        source="currentConfig.service.user"
        label="resources.integrations.fields.shiji.user.label"
        helperText="resources.integrations.fields.shiji.user.helperText"
        validate={required(
          'resources.integrations.fields.shiji.user.helperText'
        )}
        variant="outlined"
        fullWidth
      />
    </Box>
    <WebhookUrl />
  </WrapperField>
);

export default ShijiInputs;
